import React, { Component } from 'react'
import './stylesheets/userprofile.css'
import Header from '../../components/header/Header'
import {getProfile} from '../../modules/serverCall'
import "react-datepicker/dist/react-datepicker.css";



export default class UserProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      profiledata:''
    }
  }


 

  componentDidMount () {
    window.scrollTo(0, 0);
    const accesstokendata =  localStorage.getItem('access_token');
    const readData = JSON.parse(accesstokendata);
    const cusId =  readData.userdata.user_id;
    const fetchprofile = async () => {
      const responsejobs = await getProfile(cusId);
      const datarespjobs  = await responsejobs;
      this.setState({
        profiledata:datarespjobs
      });
    };
    fetchprofile();
  }


  render() {
    var profiledata = JSON.parse(localStorage.getItem('profiledata'));
    var DisplayName = '';
    var LoginID = '';
    var BranchName = '';
    var SiteName = '';
    if(profiledata !=='' && profiledata !==null && profiledata !== undefined){
      DisplayName = profiledata.DisplayName;
      LoginID = profiledata.LoginID;
      BranchName = profiledata.BranchName;
      SiteName = profiledata.SiteName;
    }
   const avatar = require ('../../assets/images/avatar7.png');
   
    return (
      <div>
      <Header/>
        <div className="mb-4 p-3 d-flex justify-content-center"> 
          <div className="card cardprofile p-4"> 
            <div className=" image d-flex flex-column justify-content-center align-items-center"> 
              <button className="btnprofile btn-secondary"> 
                <img src={avatar} height="100" alt="avatar" width="100" /></button> 
                <span className="name mt-3">{DisplayName}</span> 
                    <div className="d-flex flex-row justify-content-center align-items-center gap-2"> 
                      <span className="idd1">{LoginID}</span> 
                        <span><i className="fa fa-copy"></i></span> 
                    </div> 
                    <div className="d-flex flex-row justify-content-center align-items-center mt-3"> 
                    </div> 
                    
                    <div className="text mt-3"> 
                    <span>{BranchName}, {SiteName}</span> 
                    </div> 
            </div> 
          </div>
        </div>
      </div>

    )
  }
}





